import React from "react";

import { UnsuccesfullListContainer, ListItem, Email, Reason } from "./styles";

const UnsuccesfullList = ({ emailsWithReasons }) => {
  return (
    <UnsuccesfullListContainer>
      {emailsWithReasons.map((item, index) => (
        <ListItem key={index}>
          <Email>{item.email}</Email>
          <Reason>{item.reason}</Reason>
        </ListItem>
      ))}
    </UnsuccesfullListContainer>
  );
};

export default UnsuccesfullList;
